// import { useQuery } from "@tanstack/react-query";
// import axios from "axios";
// import API from "../api/api";

// async function getHomePage() {

//     const { data } = await axios.get(`${API}/home`);

//     return data;

// }

// export default function useHomePage() {

//     return useQuery({

//         queryKey:["homepage"],

//         queryFn:getHomePage,

//         staleTime:1000*60*20,

//         gcTime:1000*60*60,

//         refetchOnWindowFocus:false

//     });

// }

import { useQuery } from "@tanstack/react-query";

import { getHomePage } from "../services/homeService";

export default function useHomePage(){

    return useQuery({

        queryKey:["homepage"],

        queryFn:getHomePage,

        staleTime:1000*60*20,

        gcTime:1000*60*60,

        retry:2,

        refetchOnWindowFocus:false,

        refetchOnReconnect:false,

        refetchOnMount:false

    });

}